<template>
  <a
      v-if="data && data.id"
      class="card-link"
      @click.prevent="handleClick"
  >
    <div class="card">

      <!-- 左侧图片：有图片时才显示 -->
      <div class="image-area">
        <div class="image-container">
          <img
              :src="data.img"
              alt="..."
              class="card-img"
          >
        </div>
      </div>

      <!-- 右侧文字区域 -->
      <div class="card-info">

        <!-- 标题 -->
        <div class="header">
          <h5 class="card-title">
            {{ data.name }}
          </h5>

          <!-- 日期 + 收藏 -->
          <div class="ri">
            <i class="bi bi-clock riqiziti">
                            <span>
                                &nbsp;{{ formatDate(data.createTime) }}
                            </span>
            </i>

            <i class="bi bi-star-fill riqiziti">
                            <span>
                                &nbsp;{{ data.collectCount }}{{ data.collection }}
                            </span>
            </i>
          </div>
        </div>

        <!-- 中间文字 -->
        <div class="content">
          <p
              class="card-text"
              :title="data.history"
          >
            {{ getMiddleHistory(data.history) }}
          </p>
        </div>

        <!-- 底部地区 -->
        <div class="footer">
                    <span class="bi bi-send-fill weiz changlv">
                        &nbsp;{{ data.province }}-{{ data.city }}
                    </span>
        </div>

      </div>


    </div>
  </a>
</template>


<script>
export default {
  name: 'ZhaiBACardPC',

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  methods: {

    /**
     * 点击卡片
     */
    handleClick() {
      this.$emit('click');

      window.open(
          `/details2?id=${this.data.id}`,
          '_blank'
      );
    },


    /**
     * 格式化日期
     */
    formatDate(time) {
      if (!time) {
        return '';
      }

      return String(time).substring(0, 10);
    },


    /**
     * 从整段 history 的正中间取19个字符
     *
     * 最终：
     *
     * ...xxxxxxxxxxxxxxxxxxx...
     *
     * CSS会根据宽度自动换成两行
     */
    getMiddleHistory(text) {

      if (!text) {
        return '';
      }

      // 去掉首尾空格
      text = String(text).trim();

      const chars = Array.from(text);

      const showLength = 19;

      // 不超过19个字，直接显示
      if (chars.length <= showLength) {
        return chars.join('');
      }

      // 从整段文字正中央取19个字符
      const start = Math.floor(
          (chars.length - showLength) / 2
      );

      const middleText = chars
          .slice(start, start + showLength)
          .join('');

      return `...${middleText}...`;
    }
  }
};
</script>


<style scoped>

/* =========================
   外层链接
   ========================= */

.card-link {
  display: block;

  width: 100%;
  height: 100%;

  text-decoration: none;

  color: inherit;
}


/* =========================
   整个卡片
   ========================= */

.card {
  width: 100%;
  height: 155px;

  box-sizing: border-box;

  border: none;
  border-radius: 6px;

  background: #fff;

  cursor: pointer !important;

  /*
   * 最关键：
   * 左边图片固定宽度（有图时）
   * 右边文字自动占满
   */
  display: flex;
  flex-direction: row;

  overflow: hidden;
}


/* =========================
   右侧文字
   ========================= */

.card-info {

  /*
   * 自动占用除了图片之外的全部空间
   */
  flex: 1;

  /*
   * 非常重要
   * 防止 flex 子元素撑宽
   */
  min-width: 0;

  height: 100%;

  box-sizing: border-box;

  padding:

      12px
      10px
      10px
      5px;

  display: flex;

  flex-direction: column;
}


/* =========================
   标题
   ========================= */

.header {
  flex-shrink: 0;
}


.card-title {
  margin: 0 0 7px 0;

  padding: 0;

  font-size: 1rem;

  font-weight: 500;

  line-height: 1.4;

  white-space: nowrap;

  overflow: hidden;

  text-overflow: ellipsis;
}


/* =========================
   日期 + 收藏
   ========================= */

.ri {
  display: flex;

  align-items: center;

  height: 20px;

  font-size: 0.8rem;

  color: #888;
}


.riqiziti {
  display: inline-flex;

  align-items: center;

  font-style: normal;

  font-size: 0.8rem;

  margin-right: 8px;
}


.ri i + i {
  margin-left: 4px;
}


/* =========================
   中间 history
   ========================= */

.content {

  /*
   * 自动撑满中间区域
   */
  flex: 1;

  min-height: 0;

  display: flex;

  align-items: center;

  /*
   * 图2是左对齐
   */
  justify-content: flex-start;

  overflow: hidden;
}


/*
 * 重点就在这里
 */
.card-text {

  margin: 0 !important;

  padding: 0;

  width: 100%;

  font-size: 0.9rem !important;

  line-height: 1.65;

  color: #333;

  text-align: left;

  /*
   * 允许自然换行
   *
   * 不要 nowrap
   */
  white-space: normal;

  /*
   * 中文可以自然换行
   */
  word-break: break-all;

  overflow-wrap: break-word;
}


/* =========================
   底部地址
   ========================= */

.footer {
  flex-shrink: 0;

  height: 24px;

  display: flex;

  align-items: center;
}


.weiz {
  font-size: 0.9rem;
}


.changlv {
  color: #18b371 !important;
}


/* =========================
   左侧图片区域
   ========================= */

.image-area {

  /*
   * 图片区域固定宽度
   * 有图片时固定宽度
   * 无图片时 v-if 不渲染，不占空间
   */
  flex: 0 0 115px;

  width: 115px;

  height: 155px;

  display: flex;

  align-items: center;

  justify-content: center;

  box-sizing: border-box;
}


/* 图片 */
.image-container {

  width: 99px;

  height: 132px;

  overflow: hidden;

  border-radius: 4px;
}


.card-img {

  display: block;

  width: 100%;

  height: 100%;

  object-fit: cover;
}

</style>